import { pageLanguage, siteUrls } from './Data';
import { KonamiCode } from './konami';

// The hidden console: it waits for the Konami code on every page and starts itself.
export function startPageConsole() {
  const mountPoint = document.createElement('div');
  document.body.prepend(mountPoint);
  new KonamiCode({
    callback: () => {
      // The console brings a whole RISC-V emulator, only load it when someone finds it.
      import(/* webpackChunkName: "console" */ './Console').then(({ openConsole }) => openConsole(mountPoint, siteUrls(pageLanguage())));
    }
  });
}
